import createVueComponent from '../createVueComponent';

const ChevronsRight = createVueComponent('ChevronsRightIcon', [
  ['path', { d: 'm6 17 5-5-5-5', key: 'xnjwq' }],
  ['path', { d: 'm13 17 5-5-5-5', key: '17xmmf' }],
]);

export default ChevronsRight;
